import { InputGroup, FormGroup, FormControl } from 'react-bootstrap';
import React from 'react';

const getValidationStyle = (touched, errorMsg) => {
  if (!errorMsg || !touched) {
    return '';
  }
  return 'error';
};

const getBorderStyle = (touched, errorMsg) => {
  const style = {
    border: '1px solid #ccc',
    borderBottom: 'none',
    textAlign: 'right',
    paddingRight: '10px',
  };
  if (touched && errorMsg) {
    style.border = '1px solid #a94442';
    style.borderBottom = '1px solid #a94442';
  }
  return style;
};

export const PercentageInput = ({ input, label, type, meta: { touched, error, warning } }) => (
  <FormGroup validationState={getValidationStyle(touched, error)}>
    <InputGroup
      style={{
        display: 'table',
        width: '50%',
      }}
    >
      <InputGroup.Addon>{label}</InputGroup.Addon>
      <FormControl {...input} type={type} style={getBorderStyle(touched, error)} />
      <InputGroup.Addon>%</InputGroup.Addon>
    </InputGroup>
    <FormControl.Feedback />
  </FormGroup>
);
export default PercentageInput;



// WEBPACK FOOTER //
// src/forms/PercentInput.js